import { FC, useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { AppLoader } from 'components/Core/AppLoader';
import { ProductBasicForm } from 'components/Forms/ProductBasicForm/ProductBasicForm';
import { EntityTitle } from 'components/Core/EntityTitle/EntityTitle';
import { productTranslations } from './translations';
import { ProductTransFields } from './types';
import styles from './product.module.scss';

const Product: FC = observer(() => {
  const {
    productsStore: { selectedProduct: productBasicData, getProduct, setSelectedProduct },
  } = useStore();

  const { t } = useMyTranslations<ProductTransFields>([productTranslations.name]);

  const { id } = useParams();

  const { isFetching } = useQuery('getProduct', () => (id ? getProduct(id) : {}), {
    retry: false,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    return () => setSelectedProduct(null);
  }, []);

  const title = useMemo(() => {
    if (productBasicData) {
      return `${t(productBasicData.isFromNewspaper ? 'titleFromCatalogue' : 'title')} "${productBasicData.name || id}"`;
    }
    return t('addTitle');
  }, [productBasicData, id]);

  return (
    <main className={styles.page}>
      <EntityTitle title={title} deletedDate={productBasicData?.deletedDate} />
      <div className={styles.container}>{isFetching ? <AppLoader /> : <ProductBasicForm />}</div>
    </main>
  );
});

export default Product;
